// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"70b5a832","833":"904cbcf1"}[chunkId] + ".chunk.js";
};